import { isDirectAddOrderLayout } from "src/utils/posLayout/posLayout";

export const shouldShowReceiptStaffInfo = ({
  cartData,
  user,
  configurations = {},
}) => {
  const shouldUseDirectAddOrderFlow = isDirectAddOrderLayout(user);

  if (shouldUseDirectAddOrderFlow) return true;

  return (
    (cartData?.cartType || cartData?.orderType) !== "takeAway" ||
    configurations?.isTakeawayAvailableInPos === true
  );
};

export const shouldShowReceiptOrderType = ({ user, configurations = {} }) => {
  const shouldUseDirectAddOrderFlow = isDirectAddOrderLayout(user);

  if (!shouldUseDirectAddOrderFlow) return true;

  return (
    configurations?.isTakeawayAvailableInPos === true ||
    configurations?.isDineInAvailableInPos === true ||
    configurations?.isDeliveryAvailableInPos === true
  );
};